import { Link } from "@tanstack/react-router";
import { Twitter, Send } from "lucide-react";
import logoAsset from "@/assets/robotdex-logo.jpg.asset.json";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-border/60 bg-card/40 backdrop-blur-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <img src={logoAsset.url} alt="RobotDex" className="h-8 w-8 rounded object-cover" />
            <span className="text-lg font-bold neon-text">RobotDex</span>
          </Link>
          <p className="mt-3 text-muted-foreground text-xs">
            Fully on-chain NFT marketplace on Robinhood Chain & all EVM networks.
          </p>
        </div>
        <div>
          <div className="font-semibold mb-2">Marketplace</div>
          <ul className="space-y-1.5 text-muted-foreground">
            <li><Link to="/market" className="hover:text-primary">Market</Link></li>
            <li><Link to="/create" className="hover:text-primary">Create</Link></li>
            <li><Link to="/collections" className="hover:text-primary">Collections</Link></li>
            <li><Link to="/activity" className="hover:text-primary">Activity</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-2">Company</div>
          <ul className="space-y-1.5 text-muted-foreground">
            <li><Link to="/terms" className="hover:text-primary">Terms</Link></li>
            <li><Link to="/security" className="hover:text-primary">Security</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-2">Community</div>
          <div className="flex items-center gap-3 text-muted-foreground">
            <a href="https://twitter.com/robotdex" target="_blank" rel="noreferrer" aria-label="Twitter" className="hover:text-primary">
              <Twitter className="h-5 w-5" />
            </a>
            <a href="https://t.me/robotdex" target="_blank" rel="noreferrer" aria-label="Telegram" className="hover:text-primary">
              <Send className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-border/60 py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} RobotDex. All rights reserved.
      </div>
    </footer>
  );
}
